import { Yield } from '../../abacus/interfaces/yield.interface'

export const maturityYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Description',
    property: 'description'
  }
]
